var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#ABBED0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 3.1c0 1.16-3.134 2.101-7 2.101s-7-.94-7-2.1C1 1.94 4.134 1 8 1s7 .94 7 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3.1v4.917c0 1.16-3.134 2.1-7 2.1s-7-.94-7-2.1V3.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 7.983V12.9c0 1.16-3.134 2.1-7 2.1s-7-.94-7-2.1V7.983"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildIcon);
export default __webpack_public_path__ + "static/media/build-icon.67fb7cb0.svg";
export { ForwardRef as ReactComponent };